/**
 * @description 文件来源编号
 */
export enum OriginSnEnum {
	LS = 3101, // 律所
	VALUEABLE_BOOK = 4101, // 宝典
}
